import {useCallback, useState} from "react";

export function useMessages() {
    const [messages, setMessages] = useState([]);

    // Добавление нового сообщения (в конец, например из сокета)
    const addMessage = useCallback((message) => {
        setMessages((prev) => {
            const merged = [...prev, message];
            // Убираем дубли по id
            const unique = Array.from(new Map(merged.map(m => [m.id, m])).values());
            // Сортируем по дате
            return unique.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
        });
    }, []);

    // Добавление пачки старых сообщений (например, из API при скролле вверх)
    const prependMessages = useCallback((newMessages) => {
        setMessages((prev) => {
            const merged = [...newMessages, ...prev];
            const unique = Array.from(new Map(merged.map(m => [m.id, m])).values());
            return unique.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
        });
    }, []);

    const updateMessage = useCallback((newMessage) => {
        setMessages((prev) => {
            return prev.map(m => {
                if (m.id === newMessage.id) {
                    return newMessage;
                }
                return m;
            });
        })
    }, []);

    // Сброс при смене чата
    const resetMessages = useCallback(() => {
        setMessages([]);
    }, []);

    return {messages, addMessage, prependMessages, resetMessages, updateMessage};
}
